import { Flow } from 'screens/Applications&WorkOrders/RouteAdmin';
import { OperationType as OperationTypeEnum } from 'components/RecordsListView/constants';
import { OperationDetails } from '../types';

interface DuplicateLocationState {
  operation: OperationDetails;
  flow: Flow.DUPLICATE;
  operationType: 'application' | 'work-order';
}

// eslint-disable-next-line import/prefer-default-export
export const createDuplicateLocationState = (
  operation: OperationDetails,
  operationType: OperationTypeEnum
): DuplicateLocationState => {
  const isApplication = operationType === OperationTypeEnum.APPLICATION;

  return {
    operation,
    flow: Flow.DUPLICATE,
    operationType: isApplication ? 'application' : 'work-order'
  };
};
